import React from 'react'
import {FieldPickerType} from "../../../../../render/picker";

// const debug = "FieldSelectField_PickerValueNotEmpty"
const debug = false

export default function FieldSelectField_PickerValueNotEmpty(props:any) {

    // search for '_PickerValueNotEmpty' for examples...

    debug && console.log(debug, 'render', props)

    switch (props.type) {
        case FieldPickerType.TEXT:
            return (
                <div className="ui5-field-picker" onClick={props.onClick}>
                    <div className={Classes("icon", props.field.icon, props.configOptions?.iconClass || props.options?.iconClass)}/>
                    <div className="picker-label">{props.configOptions.label}</div>
                    {props.children}
                </div>
            )
        default:
            return (
                <div className="ui5-field-picker" onClick={props.onClick}>
                    <div className={Classes("icon", props.field.icon, props.configOptions?.iconClass || props.options?.iconClass)}/>
                    {props.children}
                </div>
            )
    }
}
